import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Layout from "../components/Layout";
import "./Payment.css";

function Payment() {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const API = process.env.REACT_APP_API_URL;
  const certId = searchParams.get("certId");

  useEffect(() => {
    if (!certId) {
      setError("Certificate ID is required");
    }
  }, [certId]);

  const handlePayment = async () => {
    try {
      setLoading(true);
      setError(null);

      const res = await fetch(`${API}/api/payment/create-order`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ certificateId: certId }),
      });

      const data = await res.json();
      console.log("Cashfree response:", data);

      if (!data.success || !data.payment_session_id) {
        throw new Error("Invalid Cashfree session");
      }

      if (!window.Cashfree) {
        throw new Error("Cashfree SDK not loaded");
      }

      const cashfree = window.Cashfree({
        mode:"production",
      });

      // ❌ DO NOT await
      cashfree.checkout({
        paymentSessionId: data.payment_session_id,
        redirectTarget: "_self",
      });
    } catch (err) {
      console.error(err);
      setError(err.message || "Payment failed");
      setLoading(false);
    }
  };

  if (!certId) {
    return (
      <Layout>
        <div className="page-container">
          <div className="card reveal reveal-up" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '3rem', marginBottom: '0.75rem' }}>⚠️</div>
            <p style={{ fontWeight: 600, color: '#dc2626', fontSize: '1.1rem' }}>Certificate ID missing.</p>
            <p style={{ color: '#64748b', marginTop: '0.5rem', fontSize: '0.9rem' }}>Please go back and select a certificate to proceed.</p>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="page-container">
        <div className="page-header reveal reveal-up">
          <div className="page-badge">
            <span className="float-soft" style={{ display: 'inline-block' }}>💳</span> Secure Payment
          </div>
          <h1 className="page-title">
            A small amount of appreciation will encourage our Team ❤️
          </h1>
          <p className="page-subtitle">
            Certificate will be sent to your registered Email Id and you can
            download it anytime through Download Certificate Page
          </p>
        </div>

        <div className="card reveal reveal-up stagger-2 shimmer-border" style={{ position: 'relative' }}>
          {error && (
            <div className="result-card error">
              <p style={{ fontWeight: 600, color: '#dc2626' }}>{error}</p>
            </div>
          )}

          <div className="payment-summary" style={{ position: 'relative', overflow: 'hidden' }}>
            <div className="detail-row">
              <span>Certificate ID:</span>
              <span style={{ fontFamily: "'Courier New', monospace", fontSize: '0.9rem' }}>{certId}</span>
            </div>
            <div className="detail-row">
              <span>Amount:</span>
              <span style={{
                fontSize: '1.5rem',
                fontWeight: 800,
                background: 'linear-gradient(135deg, #2563eb, #7c3aed)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}>₹99</span>
            </div>
          </div>

          <button
            className="btn btn-primary"
            onClick={handlePayment}
            disabled={loading}
            style={{ marginTop: "2rem" }}
          >
            {loading ? (
              <>
                <span className="loading-spinner" /> Processing...
              </>
            ) : (
              "💳 Pay ₹99 Now"
            )}
          </button>

          {/* Security badges */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginTop: '1.5rem', flexWrap: 'wrap' }}>
            {['🔒 SSL Encrypted', '🛡️ PCI Compliant', '✅ Instant Receipt'].map((item) => (
              <span key={item} style={{
                fontSize: '0.7rem', color: '#94a3b8', fontWeight: 500,
                display: 'flex', alignItems: 'center', gap: '0.2rem',
              }}>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Payment;
